let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2uoBF"), load("b6JBs")]).then(() => parcelRequire('g3Wvh'));